import { StepValidationState } from "../../../../../interfaces/step";
import { SearchStepper } from "../search-stepper";
import { BusinessReportReviewComponent } from "projects/reg-hub-client/src/app/orders/business-report-review/business-report-review.component";

export class UnitedStatesBusinessReportStepper extends SearchStepper {

    constructor() {
        super()

        this.steps = [
            { title: "Review", content: BusinessReportReviewComponent, validationState: StepValidationState.DefaultState }
        ];
    }
}
